import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';

import PbxContext from '../../../context/PbxContext';

import { accessLocalStorage, valuesAnalyze, changeViewForms, exportSelectAllTrunks, applyDialplanSystem, externalDialplan, readAllTenant } from '../../../services';
import FormExternalCalls from './components/formIpSetDialPlanExternal';

import '../../../libs/bulma.min.css';

function DialplanExternalCalls() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsHidden, toggleIsChangeFormElementsActive, toggleIsChangeFormElements, itemsSelectedToEdit } = getItensStateGlobal;

  let url = window.location.href;
  url = url.split('/')[2];

  const history = useHistory();

  const [values, setValues] = useState({
    external: {
      type: "",
      trunk: "",
      mask: "",
      timeout: 0,
      only: false,
      remove: {
        status: false,
        qtt: 0
      },
      code: ""
    }
  });
  const [validate, setValidate] = useState({});
  const [disable, setDisable] = useState(true);
  const [trunks, setTrunks] = useState([]);
  const [remove, setRemove] = useState(true);
  const [toggleOverflowRedirect, setToggleOverflowRedirect] = useState('');
  const [resultMessage, setResultMessage] = useState({});
  const [tenants, setTenants] = useState([]);

  const { changeBorderImputToRedOrNormal, changeVisibityMessages} = changeViewForms;

  const validateUserLogged = useCallback(async () => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    const { user: { role, idtenant } } = dataUser;
    if (!dataUser) return history.push('/');
    if (dataUser && role !== 'root') return history.push('/home');

    const trunksList = await exportSelectAllTrunks();
    if (typeof trunksList === 'undefined') return setLoading(true);
    let trunksFetched = idtenant.includes('vgs') ? trunksList : trunksList.filter((trunk) => idtenant.includes(trunk.tenant));
    setTrunks(trunksFetched);


    let fetchTenants = await readAllTenant();
    if (!fetchTenants) return;
    if (!idtenant.includes('vgs')) fetchTenants = fetchTenants.filter((tenant) => tenant.short_name === idtenant);
    setTenants(fetchTenants);
    return;
  }, []);

  const changeScreen = (check, name) => {
    changeBorderImputToRedOrNormal(check, name);
    changeVisibityMessages(!check, `${name}-placeholder-data`);
    changeVisibityMessages(check, `${name}-invalid-data`);
  };

  const handleChangeDataAnalyze = (name, value) => {
    const { checkNumber, isQuadChar } = valuesAnalyze;

    let checkValueIsCharacters = false;
    
    if (name === 'trunk' || name === 'mask' || name === 'type' || name === 'tenant') checkValueIsCharacters = Number(value.length) >= 3 && isQuadChar(value) ? true : false;
    if (name === 'only' || name === 'remove-status') checkValueIsCharacters = value === 'true' || value === 'false' ? true : false;
    if (name === 'timeout') checkValueIsCharacters = Number(value) >= 5 && valuesAnalyze.checkNumber(Number(value)) ? true : false;
    if (name === 'remove-qtt') checkValueIsCharacters = Number(value) >= 0 && valuesAnalyze.checkNumber(Number(value)) ? true : false;
    if (name === 'code') checkValueIsCharacters = !isNaN(value) && value.length === 3 ? true : false;

    changeScreen(checkValueIsCharacters, name);
    return checkValueIsCharacters;
  };

  const handleChangeValues = (item) => {
    const { name, value } = item;

    const itemStatus = handleChangeDataAnalyze(name, value);
    // setValidate((prevState) => prevState, validate[name] = itemStatus === undefined  ? true : itemStatus);

    setValidate((prevState) => {
      let nameTmp = values.external.remove.status;
      
      const vld = validate[name] = itemStatus === undefined  ? true : itemStatus
      if (name === 'status') nameTmp = value === 'true';
      if (Object.keys(prevState).length === 7 && nameTmp === false && !Object.values(prevState).includes(false)) setDisable(false);
      if (Object.keys(prevState).length === 8 && nameTmp === true && !Object.values(prevState).includes(false)) setDisable(true);
      if (Object.keys(prevState).length === 9 && !Object.values(prevState).includes(false) && nameTmp === true) setDisable(false);

      return { ...prevState, ...vld }
    });

    let nameList = [];
    name.includes('-') ? nameList = name.split('-') : setValues((prevState) => prevState, values['external'][name] = value);
    if (name === 'only') setValues((prevState) => prevState, values['external'][name] = value === 'true');
    if (nameList.length > 0 && nameList.length === 2) setValues((prevState) => prevState, values['external']['remove'][nameList[1]] = value);
    if (nameList.length > 0 && nameList.length === 2 && name === 'remove-status') setValues((prevState) => prevState, values['external']['remove'][nameList[1]] =  value === 'true');

    if (values.external.remove.status === true) {
      setRemove(false);
    } else {
      setRemove(true);
    }
    return;
  };

  const sendDataDialplanEntrance = async () => {
    const sendExternalDialplan = await externalDialplan(values);
    const result = Object.keys(sendExternalDialplan).length > 0 ? true : false;
    console.log(values);

    // if(result) {
      
    //   toggleIsHidden('#button-send-form');
    //   toggleIsHidden('#alert-create-call-external');
    //   toggleIsHidden('#button-send-apply');
    // };
    return;
  };

  const sendApplyConfig = async () => {
    const apply = await applyDialplanSystem();
    setResultMessage(apply);
    
    toggleIsHidden('#alert-create-call-external');
    toggleIsHidden('#alert-return-call-external');
    toggleIsHidden('#button-send-apply');
    toggleIsHidden('#form-entrace');

    setTimeout(() => {
      return window.location.reload(true)
    }, 3000);
  };


  useEffect(() => {
    validateUserLogged();
  }, [validateUserLogged]);

  return (
    <div>
      <div className="columns has-text-centered">
        <div className="column is-half is-offset-one-quarter has-text-centered">
          <strong className="is-size-3">CHAMADAS DE SAÍDA</strong>
          <hr className="dropdown-divider"/>
        </div>
      </div>
      <article id="alert-create-call-external" name="alert-create-call-external" className="column is-half is-offset-one-quarter message is-info is-hidden">
        <div className="message-header">
          <p>Atenção!</p>
          <button className="delete" aria-label="delete" onClick={ () => {
            toggleIsHidden('#alert-create-call-external');
            toggleIsHidden('#button-send-form');
            toggleIsHidden('#button-send-apply');
          }}></button>
        </div>
        <div className="message-body">
          Para as configurações serem aplicadas será necessário clicar no botão <strong>Aplicar</strong> abaixo.
          <br />
        </div>
      </article>
      <article id="alert-return-call-external" name="alert-create-call-external" className="column is-half is-offset-one-quarter message is-link is-hidden">
        <div className="message-header">
          <p>Atenção!</p>
          <button className="delete" aria-label="delete" onClick={ () => {
            toggleIsHidden('#alert-return-call-external');
            toggleIsHidden('#button-send-apply');
          }}></button>
        </div>
        <div className="message-body">
          { resultMessage.message }
          <br />
        </div>
      </article>
      <div id="form-entrace" className="column is-full has-text-centered">
        <FormExternalCalls handleChangeValues={ handleChangeValues } trunks={ trunks } remove={ remove } tenants={ tenants } />
      </div>
      <div  className="columns mx-2">
        <div id="button-send-form" className="column mt-3 is-half is-4 is-offset-4 has-text-centered is-active">
          <div className="control">
            <button className="button is-info is-fullwidth" type="submit" onClick={ () => sendDataDialplanEntrance() } disabled={ disable }>
              <span>
                Criar Direcionamentos
              </span>
            </button>
          </div>
        </div>
      </div>
      <div className="columns mx-2">
        <div id="button-send-apply" className="column mt-3 is-half is-4 is-offset-4 has-text-centered is-hidden">
          <div className="control">
            <button className="button is-warning is-fullwidth" type="submit" onClick={ () => sendApplyConfig() }>
              <span>
                <strong>Aplicar</strong>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DialplanExternalCalls;
